import { StepperFormStep } from '@sh4res/bo-common/components';
import { AmountsStep } from '@sh4res/bo-common/components/B2bVoluntaryPayment/steps/AmountsStep';
import { ConfirmationStep } from '@sh4res/bo-common/components/B2bVoluntaryPayment/steps/ConfirmationStep';
import { PaymentStep } from '@sh4res/bo-common/components/B2bVoluntaryPayment/steps/PaymentStep';

export const voluntaryPaymentSteps: StepperFormStep[] = [
  {
    label: 'resources.bo_common.b2b.voluntary_payment_create.steps.2',
    content: <AmountsStep />,
  },
  {
    label: 'resources.bo_common.b2b.voluntary_payment_create.steps.3',
    content: <PaymentStep />,
  },
  {
    label: 'resources.bo_common.b2b.voluntary_payment_create.steps.4',
    content: <ConfirmationStep />,
    saveDisabled: (values) => !values.confirm_accuracy?.includes('yes'),
  },
];
